import { useMatches } from "react-router";

import { TOPAS_XL_SELF_DEFINED_ROUTES } from "~/self-defined-routes";
import { type DeepReadonly } from "~/utils/types";

import { type RouteConfigEntry } from "@react-router/dev/routes";

const getCustomIds = (
  routeConfig?: DeepReadonly<RouteConfigEntry[]>,
): string[] => {
  return (
    routeConfig?.reduce<string[]>((acc: string[], route) => {
      return [
        ...acc,
        ...(route.id ? [route.id] : []),
        ...getCustomIds(route.children),
      ];
    }, []) || []
  );
};

export const useIsTopasXl = () => {
  const matches = useMatches();
  const isTopasXl = matches.some((match) =>
    getCustomIds(TOPAS_XL_SELF_DEFINED_ROUTES).includes(match.id),
  );
  return { isTopasXl };
};
